<div class="container-tig">
    <div class="title">
        <h4>市场合作</h4>
    </div>
    <h4 class="text-center">字体合作开发</h4>
    <p class="title-b"></p>
    <div class="cont-item">
        <p>每个设计师都有想设计自己的字库的想法，一可以提高知名度，二还可以进行出售等，为自己多一 条收益之路，开展自己的新职业字体设计师征程。</p>
        <br>
        <p>斡仑科技有限公司邀请广大设计师与我们合作。联合开字库优势：</p>
        <br>
        <p>1.不管是电脑设计还是书法 手写，自由没有限制，根据设计师自己的风格设计。</p>
        <p>2.设计完的字体版权归设计者和字体斡仑科技 两家所有，这样版权大家可以共同持有。</p>
        <p>3.开发完的字库将在斡仑官网上出售。</p>
    </div>
    <br>
    <div class="text-center bg-white w-75 m-auto p-2">
        <h4>字体委托开发</h4>
        <p class="title-b"></p>
        <p class="text-center"> 斡仑科技有限公司委托开发蒙古文字体、字库。</p>
    </div>
    <br>
    <div class="hz-lx-cont cont-item">
        <div class="hz-lx ">
            <span class="hz-icon">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-telephone" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                  </svg>
            </span>
            <strong class="hz-lx-title ">联系我们</strong>
            <p class="hz-lx-text ">
                拨打我们的电话
                <br>
                <strong>0471-5216653</strong>
                <br> 周一 - 周五, 9:00 - 18:00
            </p>
        </div>
        <div class="hz-lx">
            <span class="hz-icon">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-envelope" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                </svg>
            </span>
            <strong class="hz-lx-title ">电子邮箱</strong>
            <p class="hz-lx-text ">
                给我们发送电子邮件
                <br>
                <strong>dev@onon.cn</strong>
                <br> 我们会尽快回复您.
            </p>
        </div>
    </div>
    <br>
    <br>
</div>